import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Label, Row, Col, Table, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField, AvFeedback } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';

import { IRootState } from 'app/shared/reducers';
import OrderBreadCrumb from '../order-breadcrumb';
import SeatPlanModal from 'app/modules/seat-plan/seat-plan-modal';
import { genTransactionTable, isIgnoreZoneSeat } from '../order-shared';
import { defaultEventTypes, EventTypes, IEventTypes } from 'app/shared/model/event.model';

export interface IPersonalInfoState {
  showModal: boolean;
  tickets: any[];
  zoneName: string;
  hidePromoCheckbox: boolean;
}

export interface IPersonalInfoProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export class PersonalInfo extends React.Component<IPersonalInfoProps, IPersonalInfoState> {
  state: IPersonalInfoState = {
    showModal: false,
    tickets: [],
    zoneName: '',
    hidePromoCheckbox: false
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const event = Storage.session.get('EVENT');
    if (event != null) {
      if (event.types && event.types !== '') {
        const eventTypes: IEventTypes = JSON.parse(event.types);
        this.setState({ hidePromoCheckbox: eventTypes.hidePromoCheckbox });
      }
    }
  }

  componentWillUnmount() {
    // this.props.reset();
  }

  submitForm = (event, values) => {
    Storage.session.set('PI', values);
    this.props.history.push('/order/payment-info');
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  onPreviewClick = (tickets, zoneName) => {
    this.setState({ tickets, zoneName, showModal: true });
  };

  render() {
    // get transaction first. If empty, get from storage
    let transaction = this.props.transaction;
    if (Object.keys(transaction).length === 0) transaction = Storage.session.get('TRANSACTION');
    const event = Storage.session.get('EVENT');

    let eventTypes: IEventTypes = {};
    if (event.types && event.types !== '') eventTypes = event.types && event.types !== '' ? JSON.parse(event.types) : defaultEventTypes;

    const displayRows = [];
    if (transaction && Object.keys(transaction).length !== 0 && transaction.tickets.length > 0) {
      transaction.tickets.forEach(tic => {
        const row = displayRows.find(r => r.session.id === tic.session.id && r.zone.id === tic.zone.id);
        if (row) {
          row.tics.push(tic.row + (tic.seat + ''));
          row.tickets.push(tic);
        } else {
          displayRows.push({
            session: tic.session,
            zone: tic.zone,
            price: tic.pricing.price,
            handlingFee: tic.pricing.handlingFee,
            tics: [tic.row + (tic.seat + '')],
            tickets: [tic]
          });
        }
      });
    }
    const isNextButtonDisabled = () => false;
    return (
      <Row className="justify-content-center">
        <SeatPlanModal
          showModal={this.state.showModal}
          handleClose={this.handleClose}
          tickets={this.state.tickets}
          zoneName={this.state.zoneName}
        />
        <Col md="8" className="bg-white">
          <OrderBreadCrumb step="3" currentLocale={this.props.currentLocale} />
          <Row className="justify-content-center mt-3">
            <Col md="12" className="text-center bg-primary">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.personalinfo.seatresult">分配結果</Translate>
              </h2>
            </Col>
            <Col md="12" className="text-center mt-3">
              <p>
                <Translate contentKey="order.personalinfo.assignNote3">如要更改訂購數量，請關閉瀏覽器再重新訂購。</Translate>
              </p>
            </Col>
            <Col md="12" className="text-center mt-3">
              {event &&
                event.seatingPlanUrl && (
                  <a target="_blank" href={event.seatingPlanUrl}>
                    <img src={event.seatingPlanUrl} className="img-fluid mh-600 mt-2 mb-2" />
                  </a>
                )}
            </Col>
            <Col md="12" className="text-center mt-3">
              {genTransactionTable(transaction, this.onPreviewClick, isIgnoreZoneSeat(event))}
            </Col>
          </Row>
          <AvForm onValidSubmit={this.submitForm}>
            <Row className="justify-content-center mt-4">
              <Col md="12" className="text-center bg-primary">
                <h2 className="mt-3 mb-3 text-light">
                  <Translate contentKey="order.personalinfo.pi">請填寫個人資料</Translate>
                </h2>
              </Col>
            </Row>
            <Row className="justify-content-center mt-4 p-2">
              <Col md="8">
                <Row>
                  <Col md="4" xs="4" className="text-right">
                    <Label for="lastName">
                      <Translate contentKey="order.personalinfo.lastname">姓</Translate>
                    </Label>
                  </Col>
                  <Col md="8" xs="8">
                    <AvField
                      type="text"
                      name="lastName"
                      placeholder="姓"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: translate('entity.validation.required')
                        },
                        maxLength: {
                          value: 50,
                          errorMessage: translate('entity.validation.maxlength', { max: 50 })
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="4" xs="4" className="text-right">
                    <Label for="firstName">
                      <Translate contentKey="order.personalinfo.firstname">名</Translate>
                    </Label>
                  </Col>
                  <Col md="8" xs="8">
                    <AvField
                      type="text"
                      name="firstName"
                      placeholder="名"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: translate('entity.validation.required')
                        },
                        maxLength: {
                          value: 50,
                          errorMessage: translate('entity.validation.maxlength', { max: 50 })
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="4" xs="4" className="text-right">
                    <Label for="email">
                      <Translate contentKey="order.personalinfo.email">電郵</Translate>
                    </Label>
                  </Col>
                  <Col md="8" xs="8">
                    <AvField
                      type="email"
                      name="email"
                      placeholder="電郵"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: translate('entity.validation.required')
                        },
                        email: {
                          errorMessage: translate('global.messages.validate.email.invalid')
                        },
                        minLength: {
                          value: 5,
                          errorMessage: translate('global.messages.validate.email.minlength')
                        },
                        maxLength: {
                          value: 254,
                          errorMessage: translate('global.messages.validate.email.maxlength')
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="4" xs="4" className="text-right pl-0">
                    <Label for="firstName">
                      {eventTypes.labelOverrideAddress ? (
                        eventTypes.labelOverrideAddress
                      ) : (
                        <Translate contentKey="order.personalinfo.address">地址</Translate>
                      )}
                    </Label>
                  </Col>
                  <Col md="8" xs="8">
                    <AvField
                      type="text"
                      name="address"
                      placeholder={eventTypes.labelOverrideAddress ? eventTypes.labelOverrideAddress : '地址'}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: translate('entity.validation.required')
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="4" xs="4" className="text-right">
                    <Label for="mobile">
                      <Translate contentKey="order.personalinfo.mobile">手機</Translate>
                    </Label>
                  </Col>
                  <Col md="8" xs="8">
                    <AvField
                      type="text"
                      name="mobile"
                      placeholder="手機"
                      validate={{
                        required: {
                          value: true,
                          errorMessage: translate('entity.validation.required')
                        }
                        /*,pattern: {
                        value: '(^[0-9]{8}$|\\+[0-9]{11})',
                        errorMessage: translate('global.messages.validate.mobile.invalid')
                      }*/
                      }}
                    />
                  </Col>
                </Row>
                {/* <Row className="mt-3 text-right">
                  <Col xs="12">
                    <p>
                      *<Translate contentKey="order.personalinfo.note1">same card holder name</Translate>
                    </p>
                  </Col>
                </Row>*/}
              </Col>
            </Row>
            <Row>
              <Col md="12" className="text-center mt-4 px-4">
                <AvGroup check>
                  <AvInput
                    type="checkbox"
                    name="agreement"
                    id="agreement"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: translate('entity.validation.required')
                      }
                    }}
                  />
                  <Label className="mt-0 mb-4" check for="agreement">
                    {' '}
                    <Translate contentKey="order.personalinfo.agreement">I agree...</Translate>
                  </Label>
                </AvGroup>
              </Col>
            </Row>
            {!this.state.hidePromoCheckbox && (
              <Row>
                <Col md="12" className="text-center mt-2 mb-4 px-4">
                  <Translate contentKey="order.personalinfo.emailPromoAgreement">
                    我想搶先透過電郵和即時通訊軟體獲得獨家優惠資訊！我了解並同意 Patotix 使用條款與隱私政策。
                  </Translate>
                  <br />
                  <AvGroup check>
                    <AvInput type="checkbox" name="declineEmailPromo" id="declineEmailPromo" />
                    <Label className="mt-0 mb-4" check for="declineEmailPromo">
                      {' '}
                      <Translate contentKey="order.personalinfo.declineEmailPromo">我不願意透過電郵接收Patotix的推廣資訊。</Translate>
                    </Label>
                  </AvGroup>
                </Col>
              </Row>
            )}
            <div className="text-center  mb-4">
              <Button color="primary" type="submit" size="xlg" disabled={isNextButtonDisabled()}>
                <Translate contentKey="order.nextstep">NEXT</Translate>
              </Button>
            </div>
          </AvForm>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  transaction: storeState.order.transaction,
  currentLocale: storeState.locale.currentLocale
});

const mapDispatchToProps = {};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);
